import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { ReaderSummaryInfo } from './ReaderSummaryInfo'

interface Props {
  hideInfoBtn?: boolean
}

export const ReaderSummaryHeader = ({ hideInfoBtn }: Props) => {
  const { colors } = useTheme()

  return (
    <FlexBox
      className={css`
        gap: 3px;
      `}
      centerAll
    >
      <Text
        type="label"
        sizing="L"
        color={colors.uiWhite}
        align="center"
        weight="500"
      >
        Reader Summary
      </Text>
      {hideInfoBtn ? null : <ReaderSummaryInfo />}
    </FlexBox>
  )
}
